import React from 'react';

interface TrustBadgeProps {
  icon: React.FC<{ className?: string }>;
  label: string;
  description: string;
}

/**
 * Small card used in a trust strip of compliance/security signals
 * (e.g. POPIA Compliant, CAPS Aligned, Encrypted).
 * Shows an icon, a primary label, and a short description beneath.
 */
const TrustBadge: React.FC<TrustBadgeProps> = ({ icon: Icon, label, description }) => {
  return (
    <div className="flex flex-col items-center text-center bg-white dark:bg-gray-900 rounded-xl border border-primary-100 dark:border-primary-900/40 shadow-sm px-4 py-5">
      <div className="w-11 h-11 rounded-lg bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center mb-3">
        <Icon className="w-6 h-6 text-primary-600 dark:text-primary-300" />
      </div>
      <p className="text-sm font-semibold text-gray-900 dark:text-white">{label}</p>
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 leading-snug">{description}</p>
    </div>
  );
};

export default TrustBadge;
